/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Energy_MetaInputs */

const en_landing_signal_energy_meta = /** @type {(inputs: Landing_Signal_Energy_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energy • 12 clients matched • High conviction`)
};

/**
* | output |
* | --- |
* | "Energy • 12 clients matched • High conviction" |
*
* @param {Landing_Signal_Energy_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_energy_meta = /** @type {((inputs?: Landing_Signal_Energy_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Energy_MetaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_energy_meta(inputs)
});